/**
 * Who said so. An engine's verdict is scoped to the run that produced it; a
 * person's outlives every run, and only a person may negate.
 */
export enum EnrichmentSource {
  Engine = 'engine',
  HumanOverride = 'human_override',
}

/**
 * The axes a question is enriched on, one assignment table each.
 *
 * Anything levelled is a score on a named scale rather than an axis of its own,
 * so Bloom's taxonomy is a `ScaleScore` against the `blooms_taxonomy` scale and
 * its rung resolves to a descriptor through that scale's points.
 */
export enum EnrichmentDimension {
  Topic = 'topic',
  QuestionType = 'questionType',
  DirectiveVerb = 'directiveVerb',
  ScaleScore = 'scaleScore',
  Relationship = 'relationship',
}
